module.exports = __webpack_public_path__ + "static/media/E10.82915df5.jpeg";